import React, { useState, useContext, useRef } from 'react'
import ReactDOM from 'react-dom'

import DataContext from './contexts/data.jsx'

const Footer = ({ setData, forceRender, handleSendOrder }) => {
    const [isSendOrderDisabled, setIsSendOrderDisabled] = useState(true),
    commentRef = useRef(null)

    const data = useContext(DataContext),
    handleChangePolicy = () => {
        setIsSendOrderDisabled(!isSendOrderDisabled)
    },
    handleChangeComment = () => {
        const newContextData = Object.assign({}, data)

        newContextData.comment = commentRef.current.value.trim()

        setData(newContextData)
    }

    return <div className="happy-order__footer">
        <h2 className="happy-order__footer-title">Комментарий к заказу</h2>

        <div className="happy-order__footer-comment">
            <textarea
                className="happy-order__input happy-order__input_comment"
                placeholder=""
                ref={ commentRef }
                onBlur={ handleChangeComment }
            />
        </div>

        <div className="happy-order__footer-policy">
            <div className="checkbox">
                <input
                    type="checkbox"
                    onChange={ handleChangePolicy }
                    name="happy-order__policy"
                    id={ `happy-order__policy` }
                    defaultChecked={ isSendOrderDisabled }
                />
                
                <label htmlFor={ `happy-order__policy` }>
                    Даю согласие на обработку <a href="/about/policy.php" target="_blank">персональных данных</a>
                </label>
            </div>
        </div>

        { data?.data?.cart_info?.summary >= 1000 ? <div className="happy-order__footer-order">
            <button
                className="button button_big button_green"
                disabled={ !isSendOrderDisabled }
                onClick={ handleSendOrder }
            >Оформить заказ</button>
        </div> : <>
            <div className="happy-order__min-order-summary">
                Минимальная сумма заказа 1 000 ₽
            </div>

            <div className="happy-order__footer-order">
                <a href="/shop/cart/" className="button button_big button_green">Вернуться в корзину</a>
            </div> 
        </> }
    </div>
}

export default Footer